"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    MenuGroupContextProvider: function() {
        return MenuGroupContextProvider;
    },
    useMenuGroupContext_unstable: function() {
        return useMenuGroupContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const MenuGroupContext = /*#__PURE__*/ _react.createContext(undefined);
const menuGroupContextDefaultValue = {
    headerId: ''
};
const MenuGroupContextProvider = MenuGroupContext.Provider;
const useMenuGroupContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(MenuGroupContext)) !== null && _React_useContext !== void 0 ? _React_useContext : menuGroupContextDefaultValue;
};
